import { clsx } from "@trydig/ui";
import { useRouter } from "next/navigation";
import { useCart } from "~/lib/hooks/useCart";
import PaymentListSVG from "~/public/icons/16px/list.svg";
import styles from "./CartSummary.module.css";

export interface CartSummaryProps {
	labels?: React.JSX.Element;
	missingYarns?: boolean;
	isCheckout?: boolean;
}

export const CartSummary = ({ labels, missingYarns, isCheckout }: CartSummaryProps) => {
	const { modal, total, shipping, grandTotal, discount, totalQuantity } = useCart();
	const router = useRouter();

	const goToCheckout = () => {
		if (modal) modal?.toggleModal();
		router.push("/checkout");
		// eventBeginCheckout({
		//   currency: currency || "",
		//   value: cart.summary?.prices.totalAsNumber,
		//   items: cart.items.map((item) => convertCartToGTagItem(item))
		// });
	};

	const closeModal = () => {
		if (modal) modal?.toggleModal();
	};

	const emptyCart = !totalQuantity;

	return (
		<div className={clsx(styles.summary, isCheckout && styles.isCheckout)}>
			<div className={styles.summaryTexts}>
				<div className={styles.subtotals}>
					<span>
						<p>Delsum</p>
						<p>{total ?? "0,-"}</p>
					</span>

					{!!discount?.vouchers?.[0]?.priceOff && (
						<span>
							<p>Rabatt</p>
							<p>{discount?.vouchers?.[0]?.priceOff ?? "0"},-</p>
						</span>
					)}

					<span>
						<p>Frakt</p>
						<p>{shipping ?? "0,-"}</p>
					</span>
				</div>

				<span className={styles.grandtotal}>
					<p>Total</p>
					<p>{grandTotal ?? "0,-"}</p>
				</span>
			</div>

			{labels}

			{modal && (
				<button
					disabled={missingYarns || emptyCart}
					onClick={goToCheckout}
					type="button"
					className={styles["checkout-button"]}
				>
					Fortsett til utsjekk
				</button>
			)}
			<PaymentListSVG />
		</div>
	);
};
